<template>
    <div class="layout-page">
         <h1>Agent Detail</h1>
         
         <div class="row mart-12">
            <div class="col-sm-6 font-smaller person">
               <span class="marr-12">
                  <span class="font-weight-bold" v-if="isMD">Marketing Director:<br /></span>
                  {{a.firstName}} {{a.lastName}}{{a.companyName | coNameFix}} - 
                  {{a.agentNumber}} ({{a.companyNumber}}/{{a.blockNumber}}) -
                  Level {{a.hierarchyLevel}}               
               </span>
            </div>
            <div class="col-sm-4 text-right">
               <hier-ddl 
                  :hierarchies="hierarchies" 
                  :selectedHierarchy="selectedHierarchy"
                  @hier-changed="hierarchyChanged"
               ></hier-ddl>
            </div>
         </div>

         <div class="row mart-12 ">

            <div class="col-sm-12 marl-12">
               <label for="userName" class="col-form-label" v-show="canShowUpdateUser">Current User Name:</label>                             
            </div>
            <div class="col-sm-2 marl-12">                  
               <input type="text" v-show="canShowUpdateUser" id="userName" name="userName" class="form-control textbox" placeholder="(user name)" readonly v-model="userName">                      
            </div>
            <div class="col-sm-4">
               <button class="btn ml-bk-white ml-corp ml-h-orange clr-btn-border update-user-btn" @click.prevent="handleUpdateUser" v-show="canShowUpdateUser">
                  <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="updatingUser"></i>
                  <span v-else>
                     <i class="fas fa-user update-user-i"></i>
                     UPDATE USER
                  </span>
               </button>                    
            </div>            
         </div>  

         <div class="row mart-24">
            <div class="col-sm-10">

               <!-- Nav tabs -->
               <ul class="nav nav-tabs">
                  <li class="nav-item">
                     <a class="nav-link active" data-toggle="tab" href="#personal" id="personal_tab">PERSONAL</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#business" id="business_tab">BUSINESS</a>
                  </li>
                  <li class="nav-item" v-if="!isMD">
                     <a class="nav-link" data-toggle="tab" href="#appointment" id="appointment_tab">APPOINTMENT</a>
                  </li>
                  <li class="nav-item">
                     <a class="nav-link" data-toggle="tab" href="#principalAgent" id="appointment_tab">PRINCIPAL AGENT</a>
                  </li>
               </ul>

               <!-- Content -->
               <div class="tab-content">

                  <!-- Personal TAB -->
                  <div id="personal" class="tab-pane fade show active">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <div class="row">
                           <div class="form-group col">
                              <label for="lastname" v-if="ap.appointment.lastName!=null">Last Name:</label>
                              <label for="lastname" v-else>Company Name:</label>
                              <p class="form-control-static">{{ap.appointment.lastName}}</p>
                           </div>
                           <div class="form-group col">
                              <label for="firstname" v-if="ap.appointment.lastName!=null">First Name:</label>
                              <p class="form-control-static">{{ap.appointment.firstName}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="agentNumber">Agent Number:</label>
                              <p class="form-control-static">{{ap.appointment.agentNumber}}</p>
                           </div>
                           <div class="form-group col">
                              <label for="emailAddress">Email Address:</label>
                              <p class="form-control-static"><a target="_blank" :href="'mailto:' + ap.appointment.emailAddress">{{ap.appointment.emailAddress}}</a></p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="phoneNumber">Phone Number:</label>
                              <p class="form-control-static">{{ap.appointment.cellNumber | phone}}</p>
                           </div>
                           <div class="form-group col">
                              <label for="npnNumber">NPN Number:</label>
                              <p class="form-control-static">{{ap.appointment.nationalProducerNumber}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col" v-if="!isMD">
                              <label for="phoneNumber">Resident State Ins.License Number:</label>
                              <p class="form-control-static"><span v-if="homeAddressIndex!=-1">({{ap.addresses[homeAddressIndex].stateCode}}) </span>{{ap.appointment.residentStateInsuranceLicenseNumber}}</p>
                           </div>
                           <div class="form-group col">
                              <label for="hier">Hierarchy:</label>
                              <p class="form-control-static">
                                 &nbsp;
                                 <span @click.prevent="gotoHier" style="cursor:pointer;">
                                    <i class="fi-interface-organization"></i>
                                 </span>
                              </p>
                           </div>
                        </div>
                        <div class="row" v-if="!isMD">
                           <div class="form-group col">
                              <label for="insurLicenses">Insurance Licenses:</label>
                              <p class="form-control-static">{{licStates}}</p>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- Business TAB -->
                  <div id="business" class="tab-pane fade">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <div class="row">
                           <div class="form-group col">
                              <label for="businessType">Business Type:</label>
                              <p class="form-control-static">{{ap.appointment.businessType}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="name">Business Name:</label>
                              <p class="form-control-static">{{ap.appointment.businessName}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="address">Address:</label>
                              <p class="form-control-static" v-if="businessAddressIndex>-1">
                                 {{ap.addresses[businessAddressIndex].address1}}<br />
                                 <span v-if="ap.addresses[businessAddressIndex].address2!=''">{{ap.addresses[businessAddressIndex].address2}}<br /></span>
                                 {{ap.addresses[businessAddressIndex].city}}, {{ap.addresses[businessAddressIndex].stateCode}} {{ap.addresses[businessAddressIndex].zipCode}}
                              </p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="businessPhone">Phone Number:</label>
                              <p class="form-control-static">{{ap.appointment.businessCellNumber | phone}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="businessFax">Fax Number:</label>
                              <p class="form-control-static">{{ap.appointment.businessFaxNumber | phone}}</p>
                           </div>
                        </div>
                     </div>
                  </div>

                  <!-- Appointment TAB -->
                  <div id="appointment" class="tab-pane fade" v-if="!isMD">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <div class="row">
                           <div class="col">
                              <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_APP), 'Application')" v-if="findDocByType(c.DOCTYP_APP)">
                                 <i class="fas fa-file-pdf"></i>
                                 Application
                              </a>
                              <span v-else class="not-found">(Application Not Available)</span>
                           </div>
                           <div class="col text-right">
                              <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_COMB_APP), 'CombinedApplication')" v-if="findDocByType(c.DOCTYP_COMB_APP)">
                                 <i class="fas fa-file-pdf"></i>
                                 Combined Application
                              </a>
                              <span v-else class="not-found">(Combined Application Not Available)</span>
                           </div>
                        </div>

                        <fieldset class="scheduler-border">
                           <legend class="scheduler-border">Agreements</legend>
                           <div class="control-group">
                              <div class="row">
                                 <div class="col-6">
                                    <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_ALLCO_AGREE), 'AllCompanyAgreement')" v-if="findDocByType(c.DOCTYP_ALLCO_AGREE)">
                                       <i class="fas fa-file-pdf"></i>
                                       All Company Agreement
                                    </a>
                                    <span v-else class="not-found">(All Company Agreement Not Available)</span>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-6">
                                    <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_COMSCHED_AGREE), 'CommissionSchedule')" v-if="findDocByType(c.DOCTYP_COMSCHED_AGREE)">
                                       <i class="fas fa-file-pdf"></i>
                                       Commission Schedule
                                    </a>
                                    <span v-else class="not-found">(Commission Schedule Not Available)</span>
                                 </div>
                              </div>
                              <div class="row">
                                 <div class="col-6">
                                    <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_REP_AGREE), 'RepresentativeAgreement')" v-if="findDocByType(c.DOCTYP_REP_AGREE)">
                                       <i class="fas fa-file-pdf"></i>
                                       Representative Agreement
                                    </a>
                                    <span v-else class="not-found">(Representative Agreement Not Available)</span>
                                 </div>
                              </div>
                           </div>
                        </fieldset>

                        <fieldset class="scheduler-border">
                           <legend class="scheduler-border">Uploaded &amp; Faxed Documents</legend>
                           <div class="control-group">
                              <div class="row">
                                 <div class="col">
                                    <div>
                                       <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_STATE_LIC), 'StateLicense')" v-if="findDocByType(c.DOCTYP_STATE_LIC)">
                                          <i class="fas fa-file-pdf"></i>
                                          State License
                                       </a>
                                    <span v-else class="not-found">(State License Not Available)</span>
                                    </div>
                                    <div>
                                       <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_EO_CERT), 'EnOCertificate')" v-if="findDocByType(c.DOCTYP_EO_CERT)">
                                          <i class="fas fa-file-pdf"></i>
                                          E &amp; O Certificate
                                       </a>
                                    <span v-else class="not-found">(E &amp; O Certificate Not Available)</span>
                                    </div>
                                    <div>
                                       <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_DRV_LIC), 'DriversLicense')" v-if="findDocByType(c.DOCTYP_DRV_LIC)">
                                          <i class="fas fa-file-pdf"></i>
                                          Driver's License
                                       </a>
                                    <span v-else class="not-found">(Driver's License Not Available)</span>
                                    </div>
                                    <div>
                                       <a class="doc-link" href="#" @click.prevent="openDoc(findDocByType(c.DOCTYP_ASGN_OF_COMM), 'AssignmentOfCommissions')" v-if="findDocByType(c.DOCTYP_ASGN_OF_COMM)">
                                          <i class="fas fa-file-pdf"></i>
                                          Assignment of Commissions
                                       </a>
                                    <span v-else class="not-found">(Assignment of Commissions Not Available)</span>
                                    </div>
                                 </div>

                                 <!-- Additional Documents -->
                                 <div class="col">

                                 </div>
                              </div>
                           </div>
                        </fieldset>
                     </div>
                  </div>

                  <!-- Principal Agent TAB -->
                  <div id="principalAgent" class="tab-pane fade">
                     <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
                     <div v-else>
                        <div class="row">
                           <div class="form-group col">
                              <label for="Principal Agent Name" v-if="principalAgent.lastName!=null">Name:</label>
                              <p class="form-control-static">{{principalAgent.firstName}} {{principalAgent.lastName}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="businessPhone">Phone Number:</label>
                              <p class="form-control-static">{{principalAgent.phoneNumber | phone}}</p>
                           </div>
                        </div>
                        <div class="row">
                           <div class="form-group col">
                              <label for="businessFax">Address:</label>
                              <p class="form-control-static" v-if=" principalAgent.address1 != null && principalAgent.address1.length > 0">
                                 {{principalAgent.address1}}<br/>{{principalAgent.city}}{{ (principalAgent.state == null) ? "" : "," }} {{ principalAgent.state }}<br/>
                                 {{ principalAgent.zip}} 
                              </p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="modal fade" id="inviteUser">
                  <div class="modal-dialog modal-lg">
                     <div class="modal-content">
                        <div class="modal-header">
                           <h3 class="modal-title">Invite User</h3>
                           <button type="button" class="close" data-dismiss="modal" @click="resetPressed">&times;</button>
                        </div>
                        <div class="modal-body">
                           <form class="needs-validation" novalidate>
                              <div v-if="this.userName != null">
                                 You want to remove the current user:
                                 <br>
                                 <br>
                                 {{userName}}
                                 <br>
                                 <br>
                                 and invite the new user below, correct?
                                 <br>
                                 <br>
                              </div>
                              <div v-else>
                                 Please provide an email address to invite a new user below.
                                 <br>
                                 <br>                        
                              </div>
                              <div class="form-group">
                                 <label for="newEmailAddress">Email Address:</label>
                                 <input type="text" id="newEmailAddress" name="newEmailAddress" placeholder="(email address)" required class="form-control" data-fieldname="EmailAddress" v-model="newEmailAddress">
                                 <div class="valid-feedback">Email filled.</div>
                                 <div class="invalid-feedback">Please fill out this field.</div>
                              </div>
                              <br>
                              They will become associated with these agent numbers once they accept your invitation.
                           </form>
                        </div>
                        <div class="modal-footer">
                           <button type="button" class="btn ml-btn ml-bk-black ml-h-corp ml-white mart-12 marb-12" data-dismiss="modal" @click="resetPressed">
                              <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="searching"></i>
                              <span v-else>                     
                                 <i class="fas fa-times"></i>
                                 NO
                              </span>
                           </button>
                           <button type="button" class="btn ml-btn ml-bk-corp ml-white mart-12 marb-12" @click.prevent="changeToNewEmail">
                              <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="searching"></i>
                              <span v-else>                     
                                 <i class="fas fa-check"></i>
                                 YES
                              </span>
                           </button>
                        </div>      
                     </div>
                  </div>
               </div>  
            </div>
         </div>
    </div>
</template>

<script>
import hierDDL from "@/components/hierarchyDDL.vue"
import Const from "@/services/Constants"
import $ from "jquery"

export default {
   components: {
        'hier-ddl': hierDDL
   },
   data() {
      return {
         found: false,
         foundAgt: null, 
         c: new Const(),
         isMD: false,
         loading: true,
         a: {},
         blank: {
            "appointment":{
               "appointmentId":0,
               "appointmentTypeId":0,
               "appointmentLinkId":0,
               "appointmentStatusId":0,
               "personId":"0",
               "agentId":0,
               "agentNumber":"",
               "lastName":"",
               "firstName":"",
               "middleName":null,
               "ssn":"0",
               "birthDate":"",
               "emailAddress":"",
               "driverLicenseNumber":"",
               "nationalProducerNumber":"",
               "residentStateInsuranceLicenseNumber":"",
               "cellNumber":null,
               "phoneNumber":"",
               "faxNumber":null,
               "businessName":"",
               "businessCellNumber":null,
               "businessPhone":"",
               "businessFaxNumber":"",
               "businessTaxID":"",
               "uploadedDt":null,
               "isDeleted":false,
               "createDt":"",
               "createdById":"",
               "updateDt":"",
               "updatedById":"",
               "status":"",
               "businessType":""
            },
            "addresses":[
               
            ],
            "states":[
               
            ],
            "answers":[
               
            ]
         },
         ap: {},
         principalAgent: {},
         homeAddressIndex: -1,
         businessAddressIndex: -1,
         hierarchies: [],
         selectedHierarchy: null,
         documents: [],
         updatingUser: false,
         userName: null,   
         userId: null,   
         newEmailAddress: '',
         searching: false,  
      }
   },
   computed: {
      licStates() {
         if (this.ap && this.ap.states && this.ap.states.length > 0) {
            let outp = ''
            this.ap.states.forEach((itm => {
               outp += itm.stateName + ", "
            }))
            outp = outp.substr(0, outp.length-2)
            return outp
         } else {
            return ""
         }
      },
      canShowUpdateUser: function() {
         return this.ap 
               && this.ap.appointment 
               && this.ap.appointment.appointmentId != 0 
               && this.userName != null
               && !this.isCurrentAgentNumberTheSameAsLoginUser()
               && this.isCurrentAgentDirectUplineTheSameAsLoginUser()
      },
   },
   async mounted() {
      this.$parent.loadingStart()
      this.loading = true;
      this.ap = this.blank
      await this.initialize()
      this.loading = false;
      this.$parent.loadingEnd()
   },
   methods: {
      isCurrentAgentNumberTheSameAsLoginUser() {
         var result = false
         var currentAgentNumber = this.$route.params.agentNumber    
         //Go through login user's agent Numbers and see whether they are the same as 
         //current agent number. 
         this.hierarchies.forEach(h => {
            if (h.agentNo == currentAgentNumber) {
               result = true
            }
         })
         return result
      },
      isCurrentAgentDirectUplineTheSameAsLoginUser() {
         var result = false
         var currentDirectUplineAgentNumber = this.$route.params.directUpline
         //Go through login user's agent Numbers and see whether they are 
         //direct upline of current agent number.   
         this.hierarchies.forEach(h => {
            if (h.agentNo == currentDirectUplineAgentNumber) {
               result = true
            }
         })
         return result         

      },
      validateEmail(email) {
         const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
         return re.test(String(email).toLowerCase());
      },        
      async changeToNewEmail() {

         var isValid = this.form.checkValidity()

         if (!isValid) {
            this.form.classList.add('was-validated')
            if (this.newEmailAddress == '') {
               this.$swal(
                  "Email Address Is Required",
                  "Please provide an Email Address",
                  "error"
               )
               return
            }
         }

         if (!this.validateEmail(this.newEmailAddress)) {
            this.form.classList.add('was-validated')
            this.$swal(
               "Email Address Format Is Invalid",
               "Please provide a valid Email Address",
               "error"                  
            )
            return
         }

         this.searching = true
         this.$parent.loadingStart()

         //Gather the selected Associated Companies' AppointmentIds.  
         var appointmentIds = []

         appointmentIds.push(this.ap.appointment.appointmentId)

         let payload = {
            userId: this.userId,
            emailAddress: this.newEmailAddress,
            appointmentIds: appointmentIds,
            createdById: this.$store.getters.appUser.userId,
         }

         await this.$user.createUserInvitation(payload) 
            .then(async item => {
               if (item == true) {
                  this.$swal(
                     "Successfully Sent Out An Agent Invitation!",
                     "An Agent invitation has been successfully sent.",
                     "success"
                  )
                  $("#inviteUser").modal('hide')
                  this.resetPressed()
                  await this.initialize()
               }
            }).catch (err => {
               this.$swal(
                  "Oops!",
                  "Cannot send an Agent Invitation at this time.  We apologize for the inconvenience.  Please try again later. If this problem persists, please contact support.",
                  "error"
               )
               this.$parent.loadingEnd()
               this.searching = false
               return
            })
         this.$parent.loadingEnd()
         this.searching = false

      },     
      async handleUpdateUser() {
         this.busying = true
         this.searching = true
         $('#inviteUser').modal('show')
         this.busying = false
         this.searching = false
      },            
      resetPressed: function() {
         this.form.classList.remove('was-validated')
         this.newEmailAddress = ''
         this.searching = false            
      },        
      async initialize() {
         if (this.$route.params.agentNumber == undefined || this.$route.params.agentNumber==null || this.$route.params.agentNumber=="") {
            this.$router.push('/')
         }
         this.a = this.$route.params
         await this.loadPrincipalAgent()
         this.hierarchies = this.$store.getters.hierarchies

         // initially set the hierarchy to match the agent record passed in
         this.hierarchies.forEach(h => {
            if (h.companyNo == this.a.companyNumber && 
                h.blockNo == this.a.blockNumber && 
                h.mgaCode == this.a.mgaCode &&
                h.agentNo == this.a.topAgentNum) 
            {
               this.selectedHierarchy = h
            }
         });

         this.form = document.getElementsByClassName("needs-validation")[0]

         let du = this.a.directUpline.trim()
         if (du == '0000' || du == '') {
            this.isMD = true
            await this.loadMd(this.a.agentNumber,this.a.companyNumber,this.a.blockNumber)
         } else {
            this.isMD = false            
            await this.loadAppointment(this.a)
         }
      },
      async loadPrincipalAgent()
      {
         var payload = {
            agentNumber : this.a.agentNumber,
            companyCode : (this.a.companyNumber == "" || this.a.companyNumber == null) ? 0 : this.a.companyNumber
         }
         await this.$agent.getPrincipalAgent(payload)
         .then(r => {
            this.principalAgent = r;
         })
      },
      async loadMd(agentNum,companyNum,blockNum) {
         let payload = {
               agentNumber: agentNum,
               companyNumber: companyNum.toString(),               
               block: blockNum.toString()
            }

            await this.$agent.getAgentDetails(payload)
            .then(r => {
               if (r) {
                  this.ap = this.blank
                  this.ap.appointment.agentNumber = r.agentNumber
                  this.ap.appointment.businessName = r.companyName
                  this.ap.appointment.emailAddress = r.emailAddress
                  this.ap.appointment.firstName = r.firstName
                  this.ap.appointment.lastName = r.lastName
                  this.ap.appointment.middleName = r.middleName
                  if (r.agentType == 'C') {
                     this.ap.appointment.businessTaxID = r.ssNumber
                     this.ap.appointment.businessCellNumber = r.phoneNumber
                     this.ap.addresses = [
                        {
                           address1: r.address1,
                           address2: r.address2,
                           city: r.city,
                           stateCode: r.state,
                           zipCode: r.zip
                        }
                     ]
                     this.businessAddressIndex = 0
                  } else {
                     this.ap.appointment.cellNumber = r.phoneNumber
                     this.ap.addresses = [
                        {
                           address1: r.address1,
                           address2: r.address2,
                           city: r.city,
                           stateCode: r.state,
                           zipCode: r.zip
                        }
                     ]
                     this.homeAddressIndex = 0
                  }
               } else {
                  this.$swal(
                     "Oops!",
                     "An error occured on loading the page. Please try again later or contact support if the problem persists.",
                     "error"
                  )  
               }
            })
            .catch (err => {
               this.$swal(
                  "Oops!",
                  "An error occured on loading the page. Please try again later or contact support if the problem persists.",
                  "error"
               )                        
            })
      },
      async loadAgent(crit) {
         let payload = {
            AgentNumber : crit.agentNumber,
            CompanyNumber : crit.companyNumber,
            BlockNumber : crit.blockNumber,
            PageSize : 1,
            PageNumber : 1,
            ParentLevels : 0,
            ChildLevels : 0
         } 
         await this.$agent.getTree(payload)
         .then((r) => {
            if (r && r.length > 0) {
               this.a = r[0]
            } else {
               this.$swal(
                  "Not Found",
                  "The current agent number was not found under the newly selected hierarchy.",
                  "warning"
               )
            }
         })
         .catch((err) => {
            this.$swal(
               "Oops!",
               "An error occurred while trying to fetch that agent # from a different hierarchy.\n\nPlease try again or contact support if the problem persists.",
               "error"
            );
         })
      },
      setAddresses() {
         const home_code = 'ADRTYP_HOME'
         const biz_code = 'ADRTYP_BUSINESS'
         this.ap.addresses.forEach((adr, index) => {
            if (adr.addressTypeCode == home_code)
               this.homeAddressIndex = index
            else if (adr.addressTypeCode == biz_code)
               this.businessAddressIndex = index
         })
      },
      gotoHier() {
         let payload = { agentNumber: this.a.agentNumber, companyNumber: this.a.companyNumber, blockNumber: this.a.blockNumber, hier: this.selectedHierarchy, directUpline: this.a.directUpline }
         this.$router.push({ name: 'agents', params: payload })
      },
      async loadAppointment(crit) {
         if (!crit) return
         let payload = {
            agentNumber: crit.agentNumber,
            companyNumber: crit.companyNumber ? crit.companyNumber.toString() : "",
            blockNumber: crit.blockNumber.toString()
         }
         await this.$appoint.findAppointment(payload)
         .then(async (r) => {
            if (r) {
               this.ap = r
               this.userName = r.user == null ? null : r.user.userName
               this.userId = r.user == null ? null : r.user.userId
               //reset business and home index
               this.businessAddressIndex = -1               
               this.homeAddressIndex = -1
               this.setAddresses()               
               //reset the documents
               this.documents = []
               // fetch the documents
               await this.loadDocuments(this.ap.appointment.personId)
            } else {
               this.ap = this.blank
               this.$swal(
                  "Hmmm...",
                  "A past appointment record was not found and some screen fields will show as blank.\n\nIf the problem persists please contact support.",
                  "warning"
               );
            }
         })
         .catch((err) => {
            this.$swal(
               "Oops!",
               "An error occurred while trying to fetch the Appointment data.\n\nPlease try again or contact support is the problem persists.",
               "error"
            );
         })
      },
      async loadDocuments(userid) {
         //if (!userid) return
         await this.$agent.getDocuments(userid)
         .then((r) => {
            if (r) {
               this.documents = r
            } 
         })
         .catch((err) => {
            this.$swal(
               "Oops!",
               "An error occurred while trying to fetch the Agent Documents.\n\nPlease try again or contact support is the problem persists.",
               "error"
            );
         })

      },
      findDocByType(typ) {
         if (typ == this.c.DOCTYP_COMSCHED_AGREE || typ == this.c.DOCTYP_COMB_APP) {
            if (this.ap && this.ap.appointment) {
               let appId = this.ap.appointment.appointmentId.toString()
               let d = this.documents.find(doc => doc.documentTypeCode == typ && doc.documentPath.includes(appId))
               if (d &&  d != null && d != undefined) {
                  return d 
               } else {
                 // not found
               }
            }
         } else {
            return this.documents.find(doc => doc.documentTypeCode == typ)
         }
      },
      async openDoc(doc, ttl)
      {
         let payload = {
            AppUserId : doc.appUserId,
            DownloadFileType: 0, // UserDoc
            Path: doc.documentPath,
            Title: ttl + '.pdf'
         }

         this.$swal({
            title: 'Download Initiated',
            html: 'Please wait...',
            timer: 1000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
            willOpen: () => { this.$swal.showLoading() },
            willClose: () => {  }
         })
            
         this.$appoint.apiDownload(payload).then(r => {
            if (this.$appoint.errors.length > 0) {
              this.$swal(
                "Document Unavailable",
                "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                "error"
              );
            } 
          }, e => {
            this.$swal(
                "Document Unavailable",
                "Unfortunately we are having trouble downloading your document at this time. Please try again later or contact us if this problem persists.",
                "error"
              );
          })
      },
      async hierarchyChanged(hier) {
         let agt = { ...this.a }
         let payload = {
            AgentNumber : hier.agentNo,
            CompanyNumber : hier.companyNo,
            BlockNumber : hier.blockNo,
            PageSize : 20,
            PageNumber : 1,
            ParentLevels : 10,
            ChildLevels : 0
         } 
         await this.$agent.getTree(payload)
         .then(async (r) => {
            if (r && r.length > 0) {
               this.found = false
               this.searchAgentInTree(r,hier.agentNo)
               if (this.found) {                 
                  this.selectedHierarchy = hier
                  let du = this.foundAgt.directUpline.trim()
                  this.a.agentNumber = hier.agentNo
                  this.a.companyNumber = hier.companyNo 
                  this.a.blockNumber = hier.blockNo     
                  this.a.hierarchyLevel = this.foundAgt.hierarchyLevel    
                  this.a.directUpline = this.foundAgt.directUpline      
                  this.a.lastName = this.foundAgt.lastName
                  this.a.firstName = this.foundAgt.firstName
                  this.a.companyName = this.foundAgt.companyName    
                  this.activate("personal")
                  if (du == '0000' || du == '') {
                     this.isMD = true                     
                     //No appointment for the MD.                     
                     await this.loadMd(this.a.agentNumber, this.a.companyNumber, this.a.blockNumber)
                  } else {
                     this.isMD = false
                     var changeA = {
                        agentNumber : this.a.agentNumber,
                        companyNumber : this.a.companyNumber,
                        blockNumber : this.a.blockNumber,                        
                     }
                     await this.loadAppointment(changeA)                         
                  }
               } else {
                  this.$swal(
                     "Not Found",
                     `This current agent was not found under the ${hier.agentNo} (${hier.companyNo}/${hier.blockNo}) hierarchy.`,
                     "warning"
                  )                  
               }

            } else {
               this.$swal(
                  "Not Found",
                  "The current agent number was not found under the newly selected hierarchy.",
                  "warning"
               )
            }
         })
         .catch((err) => {
            this.$swal(
               "Oops!",
               "An error occurred while trying to fetch that agent # from a different hierarchy.\n\nPlease try again or contact support if the problem persists.",
               "error"
            );
         })
      },
      searchAgentInTree(data,agentNo) {        
         data.forEach((item) => {
            if (item.agentNumber == agentNo) {
               this.found = true 
               this.foundAgt = item               
            } else {
               if (item.children && item.children.length > 0) {
                  this.searchAgentInTree(item.children,agentNo)
               }
            }
         })
      }, 
      activate(tab) {
         $('.nav-tabs a[href="#' + tab + '"]').tab('show')
      },      
   }
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
.tab-content {
   padding: 24px;
   min-height: 475px;
   margin-bottom: 24px;
}
.form-control-static {
   color: $corp-color;
}
fieldset.scheduler-border {
    border: 1px groove #ddd !important;
    padding: 0.5em 1.4em 1.4em 1.4em !important;
    margin: 0 0 1em 0 !important;
}

    legend.scheduler-border {
        text-align: left !important;
        width:auto;
        padding:0 10px;
        border-bottom:none;
    }

.doc-link {
   display: inline-block;
   margin-bottom: 12px !important;
}
.person {
   font-style: italic;
   color: $corp-purple;
   font-size: smaller;
   margin-left: 12px;
}
.not-found {
   display: inline-block;
   font-style: italic;
   font-size: smaller;
   color: #ccc;
   margin-bottom: 12px;
}
</style>